import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import SignUpPage from './SignUpPage';
const SignUpRoute: FuseRouteItemType = {
  path: '',
  element: <SignUpPage />,
  auth: AUTH_ROLES.onlyGuest,
};

export default SignUpRoute;
